document.addEventListener('click', function (e) {
  const radio = e.target.closest('.card-variant-options__radio');
  if (radio) {
    const wrap = radio.closest('[data-card-variant-wrap]');
    const price = wrap && wrap.querySelector('[data-card-variant-price]');
    if (price) price.textContent = radio.dataset.price;
    return;
  }
  const atcBtn = e.target.closest('[data-card-variant-atc]');
  if (atcBtn) {
    const wrap = atcBtn.closest('[data-card-variant-wrap]');
    const checkedRadio = wrap && wrap.querySelector('.card-variant-options__radio:checked');
    const variantId = checkedRadio ? checkedRadio.dataset.variantId : (wrap && wrap.dataset.singleVariantId);
    if (!variantId) return;
    atcBtn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('Add failed'); return r.json(); })
      .then(function () { atcBtn.textContent = 'Added!'; setTimeout(function () { atcBtn.textContent = 'Add to cart'; }, 1500); })
      .catch(function (err) { console.error(err); atcBtn.textContent = 'Error'; setTimeout(function () { atcBtn.textContent = 'Add to cart'; }, 1500); });
  }
});